import { DatePicker, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { NoUndefinedRangeValueType } from 'rc-picker/lib/PickerInput/RangePicker';

import { RangeDateFilterProps } from './types';

const { RangePicker } = DatePicker;

export const RangeDateFilter = ({
  rangeDate,
  setDateRange,
  rangeNotDisabled,
  disabled,
  showTooltip,
  tooltipPosition,
}: RangeDateFilterProps) => {
  const handleChangeDate = (e: NoUndefinedRangeValueType<dayjs.Dayjs> | null) => {
    if (!e) {
      setDateRange({
        endDate: null,
        startDate: null,
      });
      return;
    }

    setDateRange({
      endDate: e[1] || null,
      startDate: e[0] || null,
    });
  };

  return (
    <div>
      <Tooltip
        title={
          disabled && showTooltip
            ? 'В компании имеются устаревшие заказы, в которых отсутствует возможность фильтрации данных по дате.'
            : null
        }
        placement={tooltipPosition}
      >
        <RangePicker
          onChange={handleChangeDate}
          placeholder={['От', 'До']}
          value={[
            rangeDate.startDate ? dayjs(rangeDate.startDate) : null,
            rangeDate.endDate ? dayjs(rangeDate.endDate) : null,
          ]}
          disabled={disabled}
          disabledDate={(current) => {
            if (!rangeNotDisabled) return false;

            return (
              current &&
              (current < dayjs(rangeNotDisabled.startDate).startOf('day') ||
                current > dayjs(rangeNotDisabled.endDate).endOf('day'))
            );
          }}
        />
      </Tooltip>
    </div>
  );
};
